import styled from 'styled-components'

export const StyledBlog = styled.div`
  .blog-page {
    margin-top: 32px;
    .content {
      width: 1168px;
      margin: 0 auto;
      padding-bottom: 80px;
      h1 {
        font-size: 32px;
        line-height: 37px;
        color: #383838;
      }

      .articles {
        padding-top: 76px;
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;
      }

      .article-card {
        display: block;
        background: #ffffff;
        box-shadow: 0px 2px 12px rgba(214, 214, 214, 0.5);
        border-radius: 8px;
        width: 362px;
        height: 440px;
        margin-bottom: 40px;
        position: relative;
        margin-right: 25px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-5px);
        }

        img {
          border-radius: 8px;
          width: 100%;
          height: 180px;
          object-fit: cover;
        }

        .card-content {
          padding: 20px;
          .title {
            font-size: 20px;
            line-height: 30px;
            color: #1a1a1a;
            font-weight: 500;
            max-height: 60px;
            overflow: hidden;
          }

          .updated-at {
            font-size: 11px;
            line-height: 13px;
            color: #666666;
            position: absolute;
            bottom: 20px;
          }

          .article-body {
            margin-top: 15px;
            font-weight: 300;
            color: #666;
            height: 96px;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: wrap;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            font-size: 14px;
            line-height: 24px;
            color: #1a1a1a;

            em {
              span {
                word-break: break-all;
              }
            }
          }
        }
      }

      .load-more {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 70px;
        .button {
          display: inline-block;
          background: #098de6;
          box-shadow: 0px 2px 8px #e6e8eb;
          border-radius: 4px;
          padding: 8px 43px;
          cursor: pointer;
        }
        p {
          font-size: 18px;
          line-height: 21px;
          letter-spacing: -0.128571px;
          color: #ffffff;
          margin-bottom: 0;
        }
      }
    }
  }

  @media (max-width: 860px) {
    .blog-page {
      .content {
        padding: 0 1rem;
        width: 100%;

        .articles {
          padding-top: 40px;
        }

        .article-card {
          width: calc(100vw - 2em);
          margin-right: 0;
        }

        .load-more {
          margin-top: 40px;
          padding-bottom: 85px;
        }
      }
    }
  }
`
